"use client";

import styled from "styled-components";

export const Box = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 15px;
  width: 100%;

  @media (min-width: 670px) {
    flex-direction: row;
  }
`;
